import { useQuery } from "@apollo/client";
import { GetCurrentUserInfoDocument } from "../generated";
import { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";

export const useTrialInfo = (workspaceId?: string) => {
  const navigate = useNavigate();
  const { data } = useQuery(GetCurrentUserInfoDocument, {
    skip: !workspaceId,
  });

  const isTrialExpired = useMemo(() => {
    const org = data?.currentUser?.organization;
    if (!org?.isTrial || !org?.trialEndDate) return false;
    return new Date(org.trialEndDate) < new Date(); // expired if end date is in the past
  }, [data]);

  useEffect(() => {
    if (
      workspaceId &&
      data?.currentUser?.organization?.isTrial &&
      isTrialExpired
    ) {
      navigate(`/workspace/${workspaceId}/trial-expired`);
    }
  }, [
    data?.currentUser?.organization?.isTrial,
    isTrialExpired,
    navigate,
    workspaceId,
  ]);

  return { isTrialExpired };
};
